import { render, staticRenderFns } from "./InfoConfigVersionList.vue?vue&type=template&id=4d4fb5a1&scoped=true&"
import script from "./InfoConfigVersionList.vue?vue&type=script&lang=ts&"
export * from "./InfoConfigVersionList.vue?vue&type=script&lang=ts&"
import style0 from "./InfoConfigVersionList.vue?vue&type=style&index=0&id=4d4fb5a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4fb5a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VCard,VChip,VCol,VDivider,VHover,VIcon,VRow,VSpacer,VTooltip})
